import React, { useEffect, useMemo, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Spin, Input, Select, Modal } from "antd";
import _ from "lodash";
import * as API from "src/api/plan";
import * as REQ from "src/api/request";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { FilterMatchMode } from "primereact/api";
import { usePlanContext } from "src/contexts/planContext";
import MODAL from "src/pages/company/modal";
// import { useUserContext } from "src/contexts/userContext";
import axios from "axios";
import dayjs from "dayjs";
import AddBtn from "src/components/button/plusButton";
import useBearStore from "src/state/state";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import * as XLSX from "xlsx";

import Swal from "sweetalert2";

const ListSum = () => {
  const { state, dispatch } = usePlanContext();

  const [search, setSearch] = useState({
    global: { value: "", matchMode: FilterMatchMode.CONTAINS },
  });
  const [first, set_first] = useState(0);
  const [per_page, set_per_page] = useState(50);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const user_id = useBearStore((state) => state.user_id);
  const userInfo = useBearStore((state) => state.userInfo);
  const isUserValid = useBearStore((state) => state.isUserValid);
  const [ssum_total, setssum_total] = useState(0);
  const [sum_cash, setsum_cash] = useState(0);
  const groupData_list = {};
  const daysInMonth = new Date(
    moment(state.report.date).format("YYYY"),
    moment(state.report.date).format("MM"),
    0,
  ).getDate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          "https://tugeelt.store/api/backend/report",
          // "http://tugeelt.store/api/backend/report",
          // "http://localhost:5000/api/backend/report",
          {
            params: {
              sub_code: state.balance.seller_id,
              start_date: moment(state.report.start_date).format("YYYY.MM.01"),
              end_date: moment(state.report.end_date).format(
                "YYYY.MM." + daysInMonth,
              ),
            },
          },
        );

        const rawData = response.data.response;
        // console.log(rawData);
        // ✅ Group and sum by delguur_id + delguur_ner

        response.data.response.forEach((item) => {
          const mainGroup = item.src_company_ner || "Бусад";
          const subGroup = item.company_name || "No Name";
          const total = item.count * item.price;

          if (!groupData_list[mainGroup]) {
            groupData_list[mainGroup] = {};
          }

          if (!groupData_list[mainGroup][subGroup]) {
            groupData_list[mainGroup][subGroup] = 0;
          }

          groupData_list[mainGroup][subGroup] += total;
        });
        const cleanedData = _.mapKeys(groupData_list, (value, key) =>
          key.trim(),
        );
        console.log("group data", cleanedData);
        dispatch({
          type: "STATE",
          data: {
            gg_list: cleanedData,
          },
        });
        console.log("fetcha dataaa", groupData_list);

        var result = _(response.data.response)
          .groupBy("id_order")
          .map(function (items, id_order) {
            return {
              order_id: id_order,
              delguur_id: items[0].delguur_id,
              delguur_ner: items[0].delguur_ner,
              register_date: moment(items[0].register_date).format(
                "YYYY.MM.DD",
              ),
              cash: items[0].cash,
              count: _.sumBy(items, "count"),
              total: _.sumBy(items, "total"),
              user_name: items[0].user_name,
              phone: items[0].phone,
              is_approve: items[0].is_approve,
              is_print: items[0].is_print,
              print_date: items[0].print_date,
              is_dist: items[0].is_dist,
              dist_date_register: items[0].dist_date_register,
            };
          })
          .value();

        const groupedData = Object.values(
          result.reduce((acc, item) => {
            const key = `${item.delguur_id}_${item.delguur_ner}`;

            if (!acc[key]) {
              acc[key] = {
                delguur_id: item.delguur_id,
                delguur_ner: item.delguur_ner,
                cash: 0,
                total: 0,
              };
            }

            acc[key].total += Number(item.total) || 0; // add up totals safely
            acc[key].cash += Number(item.cash) || 0;
            return acc;
          }, {}),
        );
        setList(_.orderBy(groupedData, ["delguur_ner"]));
        console.log("groupdata-----", groupedData);

        var ssum = 0;
        _.map(result, (item) => {
          ssum += item.total;
        });
        setssum_total(ssum);
        var cashsum = 0;
        _.map(result, (item) => {
          cashsum += item.cash;
        });
        setsum_cash(cashsum);
        dispatch({
          type: "STATE",
          data: {
            balance_list: response.data.response,
            balanceGroup_list: result,
          },
        });

        // setList(
        //   _.orderBy(
        //     _.filter(response.data.response, (a) => a.id !== null),
        //     ["id"]
        //   )
        // );

        setLoading(false);
      } catch (error) {
        setLoading(false);
        // setError(error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.refresh,
    state.report.start_date,
    state.report.end_date,
    state.balance.seller_id,
  ]);

  const exportToExcel = (list) => {
    let Heading = [["№", "Дэлгүүр нэр", "Бэлэн", "Нийт", "Зээл"]];
    var result = _.map(_.orderBy(list, ["delguur_ner"]), (a, i) => {
      return {
        i: i + 1,
        ner: a.delguur_ner,

        cash: a.cash,
        total: a.total,
        laon: a.total - a.cash,
      };
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(worksheet, Heading, { origin: "A1" });
    XLSX.utils.sheet_add_json(worksheet, result, {
      origin: "A2",
      skipHeader: true,
    });
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(
      workbook,
      "Дэлгүүр" + moment().format("YYYY_MM_сар") + ".xlsx",
      {
        compression: true,
      },
    );
  };
  const deleteClick = (item) => {
    try {
      const response = axios.delete(
        "http://tugeelt.store/api/backend/company/" + item.id,
      );
      dispatch({
        type: "STATE",
        data: { refresh: state.refresh + 1 },
      });
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <div className="w-full">
      {" "}
      <Modal
        style={{ width: "600" }}
        width={800}
        height={550}
        visible={state.company.modal}
        // visible={true}
        onCancel={() => dispatch({ type: "COMPANY", data: { modal: false } })}
        closeIcon={<div className="">x</div>}
        footer={false}
      >
        <MODAL />
      </Modal>
      <Spin tip="Уншиж байна." className="bg-opacity-80" spinning={loading}>
        <DataTable
          size="small"
          value={list}
          dataKey="id"
          filters={search}
          paginator
          scrollable
          rowHover
          removableSort
          showGridlines
          className="table-xs"
          filterDisplay="menu"
          responsiveLayout="scroll"
          sortMode="multiple"
          rowGroupMode="subheader"
          groupRowsBy="negj_namemnfull"
          scrollHeight={window.innerHeight - 360}
          globalFilterFields={["delguur_ner"]}
          emptyMessage={
            <div className="text-xs text-orange-500 italic font-semibold">
              Мэдээлэл олдсонгүй...
            </div>
          }
          header={
            <div className="flex items-center justify-between">
              <div className="w-full md:max-w-[200px]">
                <Input
                  placeholder="Хайх..."
                  value={search.global.value}
                  onChange={(e) => {
                    let _search = { ...search };
                    _search["global"].value = e.target.value;
                    setSearch(_search);
                  }}
                />
              </div>
              <div className="flex items-center gap-2 ">
                {/* <div
                  title="Нэмэх"
                  className="p-1 flex items-center justify-center font-semibold text-violet-500 border-2 border-violet-500 rounded-full hover:bg-violet-500 hover:text-white hover:scale-125 focus:outline-none duration-300 cursor-pointer "
                  onClick={() => {
                    dispatch({
                      type: "COMPANY",
                      data: {
                        id: 0,
                        company_ner: "",
                        hayag: "",
                        utas: "",
                        register: "",
                        dans: "",
                        modal: true,
                      },
                    });
                  }}
                >
                  <i className="ft-plus" />
                </div> */}
                <div className="flex items-center justify-between">
                  <img
                    alt=""
                    title="Excel татах"
                    src="/img/excel.png"
                    className="w-12 h-8 object-cover cursor-pointer hover:scale-125 duration-300"
                    onClick={() => exportToExcel(list)}
                  />
                </div>
                <div className="flex items-center">
                  Нийт борлуулалт:{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "blue",
                    }}
                  >
                    {Intl.NumberFormat("en-US").format(ssum_total)}
                  </span>
                  {" |  "}
                  Бэлэн:{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "green",
                    }}
                  >
                    {Intl.NumberFormat("en-US").format(sum_cash)}
                  </span>
                  {" |  "}
                  Зээл:{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "red",
                    }}
                  >
                    {Intl.NumberFormat("en-US").format(ssum_total - sum_cash)}
                  </span>{" "}
                </div>
              </div>
            </div>

            // <div className="flex items-center justify-between  pb-2 mb-2  text-xs">

            // </div>
          }
          rowGroupHeaderTemplate={(data) => {
            return (
              <div className="text-xs font-semibold">
                <span className="ml-1">
                  {data.negj_code} | {data.negj_namemnfull}
                </span>
              </div>
            );
          }}
          rows={per_page}
          first={first}
          onPage={(event) => {
            set_first(event.first);
            set_per_page(event.rows);
          }}
          paginatorTemplate={{
            layout:
              "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
            RowsPerPageDropdown: (options) => {
              const dropdownOptions = [
                { label: 50, value: 50 },
                { label: 100, value: 100 },
                { label: 200, value: 200 },
                { label: 500, value: 500 },
              ];
              return (
                <>
                  <span
                    className="text-xs mx-1"
                    style={{
                      color: "var(--text-color)",
                      userSelect: "none",
                    }}
                  >
                    <span className="font-semibold">Нэг хуудсанд:</span>
                  </span>
                  <Select
                    size="small"
                    showSearch={false}
                    value={options.value}
                    onChange={(value) => {
                      options.onChange({
                        value: value,
                      });
                    }}
                  >
                    {_.map(dropdownOptions, (item) => (
                      <Select.Option key={item.value} value={item.value}>
                        {item.value}
                      </Select.Option>
                    ))}
                  </Select>
                </>
              );
            },
            CurrentPageReport: (options) => {
              return (
                <span
                  style={{
                    color: "var(--text-color)",
                    userSelect: "none",
                    width: "200px",
                    textAlign: "center",
                  }}
                >
                  <span className="text-xs font-semibold">
                    <span>
                      {options.first} - {options.last}
                    </span>
                    <span className="ml-3">Нийт: {options.totalRecords}</span>
                  </span>
                </span>
              );
            },
          }}
          footerColumnGroup={
            <ColumnGroup>
              <Row>
                <Column
                  colSpan={3}
                  footer={() => <div className="text-right text-xs ">Нийт</div>}
                />
                <Column
                  className="w-[80px] text-xs justify-end justify-items-end text-right"
                  footer={() => (
                    <div className="justify-items-end justify-end">
                      {Intl.NumberFormat("en-US").format(
                        _.sumBy(list, (a) => a.cash),
                      )}
                    </div>
                  )}
                />
                <Column
                  className="w-[80px] text-xs justify-end justify-items-end text-right"
                  footer={() => (
                    <div className="justify-items-end justify-end">
                      {Intl.NumberFormat("en-US").format(
                        _.sumBy(list, (a) => a.total),
                      )}
                    </div>
                  )}
                />
                <Column
                  className="w-[80px] text-xs justify-end justify-items-end text-right"
                  footer={() => (
                    <div className="justify-items-end justify-end">
                      {Intl.NumberFormat("en-US").format(
                        _.sumBy(list, (a) => a.total - a.cash),
                      )}
                    </div>
                  )}
                />
                <Column className="w-[80px] text-xs justify-end justify-items-end text-right" />
              </Row>
            </ColumnGroup>
          }
          paginatorClassName="justify-content-end"
        >
          <Column
            align="center"
            header="№"
            className="text-sm"
            style={{ minWidth: "40px", maxWidth: "40px" }}
            body={(data, row) => row.rowIndex + 1}
          />
          <Column
            // style={{ minWidth: "60px", maxWidth: "60px" }}
            field="delguur_ner"
            className="text-sm"
            header="Дэлгүүр нэр"
          />
          <Column
            style={{ minWidth: "80px", maxWidth: "80px" }}
            field="cash"
            className="text-sm"
            header="Бэлэн"
            body={(item) => {
              return Intl.NumberFormat("en-US").format(item.cash);
            }}
          />
          <Column
            field="total"
            header="Нийт"
            className="text-sm"
            style={{ minWidth: "80px", maxWidth: "80px" }}
            body={(item) => {
              return Intl.NumberFormat("en-US").format(item.total);
            }}
          />
          <Column
            field="total"
            header="Зээл"
            className="text-sm"
            style={{ minWidth: "80px", maxWidth: "80px" }}
            body={(item) => {
              return Intl.NumberFormat("en-US").format(item.total - item.cash);
            }}
          />

          <Column
            align="center"
            header=""
            className="text-xs"
            style={{ minWidth: "70px", maxWidth: "70px" }}
            headerClassName="flex items-center justify-center"
            body={(item) => {
              return (
                <div className="flex items-center justify-center gap-2">
                  <button
                    className="p-1 flex items-center justify-center font-semibold text-green-500 rounded-full border-2 border-green-500 hover:bg-green-500 hover:scale-125 hover:text-white focus:outline-none duration-300"
                    onClick={() => {
                      dispatch({
                        type: "COMPANY",
                        data: {
                          id: item.id,
                          company_ner: item.company_ner,
                          hayag: item.hayag,
                          dans: item.dans,
                          utas: item.utas,
                          register: item.register,
                          modal: true,
                        },
                      });
                    }}
                  >
                    <i className="ft-edit" />
                  </button>

                  <button
                    className="p-1 flex items-center justify-center font-semibold text-red-500 rounded-full border-2 border-red-500 hover:bg-red-500 hover:scale-125 hover:text-white focus:outline-none duration-300"
                    onClick={() => {
                      Swal.fire({
                        text: item.company_ner + "-г устгах уу",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#1890ff",
                        cancelButtonColor: "rgb(244, 106, 106)",
                        confirmButtonText: "Тийм",
                        cancelButtonText: "Үгүй",
                        reverseButtons: true,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          deleteClick(item);
                        }
                      });
                    }}
                  >
                    <i className="ft-trash" />
                  </button>
                </div>
              );
            }}
          />
        </DataTable>
      </Spin>
    </div>
  );
};

export default React.memo(ListSum);
